import React, { ForwardedRef, forwardRef } from 'react';
import { Container } from '@tishman/components';

import { selectWizardCurrentStep, useAppSelector } from '../../store';

import type { StepProps } from './Step';

type Props = Omit<StepProps, 'title' | 'stepNumber'> & {
  overrideStepNumber?: boolean;
  stepNumber?: number;
};

export const StepContainer = forwardRef(function StepContainer(
  props: Props,
  stepRef?: ForwardedRef<HTMLDivElement>,
) {
  const currentStep = useAppSelector(selectWizardCurrentStep);

  const {
    stepNumber,
    children,
    summary,
    width,
    overrideStepNumber,
    ...remainingProps
  } = props;

  const stepIsValid = overrideStepNumber || stepNumber === currentStep;

  return (
    <Container
      {...remainingProps}
      ref={stepRef}
      sx={{
        'px': [0, 16],
        'maxWidth': width === 'wide' ? 'unset' : 1040,
        'pt': stepIsValid ? 5 : 4,
        'pb': summary || stepIsValid ? 5 : 4,
        'borderBottom': '1px solid #D8D8D8',
        ':first-of-type': {
          pt: 0,
        },
        'position': 'relative',
        'scrollMarginTop': '65px',
      }}
    >
      {children}
    </Container>
  );
});

export default StepContainer;
